import moment from "@/moment-gp";
import rgen_seed from 'random-seed'

export default {

  idols: state => state.idols,

  random_quote: state => selected_idols => {

    let filtered_idols = state.idols.filter(idol => {
      return selected_idols && selected_idols.includes(idol.id)
    })
    // console.log("[quotes] state.idols", state.idols);
    console.log("[quotes] received filtered_idols", filtered_idols);

    if ( filtered_idols.length > 0 ) {

      var daily_random = rgen_seed.create( moment().format('MMDDYYYY') ); // TODO

      let num_of_idols = filtered_idols.length;
      let rand_idx_idol = daily_random(num_of_idols)

      let idol = filtered_idols[rand_idx_idol];
      let num_of_quotes = idol.quotes.length;
      let rand_idx_quote = daily_random(num_of_quotes)

      return {
        name: idol.name,
        pic: idol.pic,
        quote: idol.quotes[rand_idx_quote]
      }
    } else {
      return { name: 'nobody', pic: '', quote: 'No Quote' }
    }
  },
}
